module.exports = __webpack_public_path__ + "static/media/team-small-placeholder.8f35fd07.webp";